import type { TOC } from '@ember/component/template-only';
import { PrismModal } from '@mylighthouse/prism-ember';
import { eq } from 'ember-truth-helpers';
import ParityParityManagerAdditionalInfoForm from 'lumen/components/parity/parity-manager/additional-info-form';
import ParityParityManagerAttachmentForm from 'lumen/components/parity/parity-manager/attachment-form';
import ParityParityManagerBookingDetailsForm from 'lumen/components/parity/parity-manager/booking-details-form';
import ParityParityManagerChannelRateForm from 'lumen/components/parity/parity-manager/channel-rate-form';
import ParityParityManagerHotelRateForm from 'lumen/components/parity/parity-manager/hotel-rate-form';
import ParityParityManagerMetaRateForm from 'lumen/components/parity/parity-manager/meta-rate-form';
import type MarketParityParityManagerAddissueController from 'lumen/controllers/market/parity/parity-manager/addissue';

interface MarketParityParityManagerAddissueSignature {
  Args: {
    controller: MarketParityParityManagerAddissueController;
    model: unknown;
  };
}

<template>
  <PrismModal
    @onClose={{@controller.redirectOnClose}}
    @title={{@controller.issueFormTitle}}
  >
    <div class="modal--small">
      {{#if (eq @controller.step @controller.manualIssueSteps.HOTEL_INFO)}}
        <ParityParityManagerHotelRateForm
          @cancel={{@controller.exitForm}}
          @currencyCode={{@controller.subscriptionCurrency}}
          @isMajorOtaView={{@controller.parentController.isMajorOtaView}}
          @issue={{@controller.newIssue}}
          @next={{@controller.next}}
          @platformOptions={{@controller.platformOptions}}
          @setIssueProperty={{@controller.setIssueProperty}}
          @setIssuePropertyFromEvent={{@controller.setIssuePropertyFromEvent}}
          @toggleValue={{@controller.toggleValue}}
        />
      {{else if
        (eq @controller.step @controller.manualIssueSteps.CHANNEL_INFO)
      }}
        <ParityParityManagerChannelRateForm
          @back={{@controller.back}}
          @currencyCode={{@controller.subscriptionCurrency}}
          @issue={{@controller.newIssue}}
          @next={{@controller.next}}
          @parentController={{@controller.parentController}}
          @platformOptions={{@controller.platformOptions}}
          @setIssueProperty={{@controller.setIssueProperty}}
          @setIssuePropertyFromEvent={{@controller.setIssuePropertyFromEvent}}
          @toggleValue={{@controller.toggleValue}}
        />
      {{else if (eq @controller.step @controller.manualIssueSteps.META_INFO)}}
        <ParityParityManagerMetaRateForm
          @back={{@controller.back}}
          @currencyCode={{@controller.subscriptionCurrency}}
          @issue={{@controller.newIssue}}
          @next={{@controller.next}}
          @setIssueProperty={{@controller.setIssueProperty}}
          @setIssuePropertyFromEvent={{@controller.setIssuePropertyFromEvent}}
        />
      {{else if
        (eq @controller.step @controller.manualIssueSteps.BOOKING_DETAILS)
      }}
        <ParityParityManagerBookingDetailsForm
          @back={{@controller.back}}
          @issue={{@controller.newIssue}}
          @next={{@controller.next}}
          @setIssueProperty={{@controller.setIssueProperty}}
          @setIssuePropertyFromEvent={{@controller.setIssuePropertyFromEvent}}
        />
      {{else if (eq @controller.step @controller.manualIssueSteps.OTHER_INFO)}}
        <ParityParityManagerAdditionalInfoForm
          @back={{@controller.back}}
          @issue={{@controller.newIssue}}
          @next={{@controller.next}}
          @parentController={{@controller.parentController}}
          @setIssueProperty={{@controller.setIssueProperty}}
          @setIssuePropertyFromEvent={{@controller.setIssuePropertyFromEvent}}
        />
      {{else}}
        <ParityParityManagerAttachmentForm
          @back={{@controller.back}}
          @issue={{@controller.newIssue}}
          @parentController={{@controller.parentController}}
          @saveIssue={{@controller.saveIssue}}
          @uploadingIssue={{@controller.uploadingIssue}}
        />
      {{/if}}
    </div>
  </PrismModal>
</template> satisfies TOC<MarketParityParityManagerAddissueSignature>;
